import application from 'application/application';

application

	.directive('ngEquals', () => ({
		require: 'ngModel',
		scope: {
			ngEquals: '='
		},
		link(scope, element, attrs, controller) {

			controller.$validators.equals = modelValue => {

				if (controller.$isEmpty(modelValue))

					return true;

				return scope.ngEquals === modelValue;

			};

		}
	}));
